// extracted by mini-css-extract-plugin
export default {"container":"footer_container__GZsRq","socials":"footer_socials__GAsSp","copyright":"footer_copyright__TjMPW"};